'use client';

import { useEffect, type FC, type PropsWithChildren } from 'react';
import { userStoreActions } from '../../../_stores/user';

type SetupStoreProps = {
  userData: {
    userId: string;
    email: string;
    fff_uuid: string;
    leadUuid: string | undefined;
  };
};

export const SetupStore: FC<PropsWithChildren<SetupStoreProps>> = ({ userData, children }) => {
  useEffect(() => {
    userStoreActions.setUserData({
      isLoggedIn: !!userData.userId,
      userId: userData.userId,
      email: userData.email,
      fff_uuid: userData.fff_uuid,
      leadUuid: userData.leadUuid,
    });
  }, [userData]);

  return children;
};
